import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class SalesRegionReferenceService extends BaseReferenceService {
  constructor() {
    super('SalesRegionReference');
  }
}
